(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = null;

  function observar(el) {
    if (reducido || !('IntersectionObserver' in window)) { el.classList.add('mt-visible'); return; }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observador.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    observador.observe(el);
  }

  function initReveals(raiz) {
    raiz.querySelectorAll('.mt-reveal, .mt-reveal-izq, .mt-reveal-der, .mt-pasos').forEach(function (el) {
      if (el.dataset.mtInit) return; el.dataset.mtInit = '1'; observar(el);
    });
  }

  function initHero(raiz) {
    raiz.querySelectorAll('.mt-hero').forEach(function (h) {
      if (h.dataset.mtInit) return; h.dataset.mtInit = '1';
      requestAnimationFrame(function () { setTimeout(function () { h.classList.add('mt-listo'); }, 60); });
    });
  }

  function initManifiesto(raiz) {
    raiz.querySelectorAll('[data-mt-manifiesto]').forEach(function (bloque) {
      if (bloque.dataset.mtInit) return; bloque.dataset.mtInit = '1';
      var palabras = bloque.querySelectorAll('.mt-palabra');
      if (reducido) { palabras.forEach(function (p) { p.classList.add('mt-on'); }); return; }
      function pintar() {
        var r = bloque.getBoundingClientRect();
        var vh = window.innerHeight;
        var progreso = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
        progreso = Math.max(0, Math.min(1, progreso));
        var n = Math.round(progreso * palabras.length);
        palabras.forEach(function (p, i) { p.classList.toggle('mt-on', i < n); });
      }
      window.addEventListener('scroll', pintar, { passive: true });
      window.addEventListener('resize', pintar);
      pintar();
    });
  }

  function initFaq(raiz) {
    raiz.querySelectorAll('.mt-faq-item').forEach(function (item) {
      if (item.dataset.mtFaq) return; item.dataset.mtFaq = "1";
      var boton = item.querySelector('.mt-faq-q');
      boton.addEventListener('click', function () {
        var abierto = item.classList.toggle('mt-abierto');
        boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  function initGaleria(cont) {
    var pista = cont.querySelector('.mt-prod-pista');
    if (!pista) return null;
    var slides = [].slice.call(pista.querySelectorAll('.mt-prod-slide'));
    var minis = [].slice.call(cont.querySelectorAll('.mt-prod-mini'));
    var puntos = [].slice.call(cont.querySelectorAll('.mt-prod-puntos span'));
    var prev = cont.querySelector('[data-mt-prev]'), next = cont.querySelector('[data-mt-next]');
    var actualTxt = cont.querySelector('[data-mt-actual]');
    var actual = -1;
    function marcar(i) {
      if (i === actual) return; actual = i;
      minis.forEach(function (m, k) { m.classList.toggle('mt-activa', k === i); });
      puntos.forEach(function (p, k) { p.classList.toggle('mt-activo', k === i); });
      if (actualTxt) actualTxt.textContent = i + 1;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      var m = minis[i];
      if (m && m.parentNode.scrollWidth > m.parentNode.clientWidth) {
        m.parentNode.scrollTo({ left: m.offsetLeft - m.parentNode.clientWidth / 2 + m.clientWidth / 2, behavior: 'smooth' });
      }
    }
    function ir(i, suave) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      pista.scrollTo({ left: i * pista.clientWidth, behavior: suave === false ? 'instant' : 'smooth' });
      marcar(i);
    }
    function indiceVisible() { return Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth)); }
    var t;
    pista.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { marcar(indiceVisible()); }, 60);
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { ir(indiceVisible() - 1); });
    if (next) next.addEventListener('click', function () { ir(indiceVisible() + 1); });
    minis.forEach(function (m, k) { m.addEventListener('click', function () { ir(k); }); });
    pista.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); ir(indiceVisible() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); ir(indiceVisible() - 1); }
    });
    /* arrastrar con el raton en ordenador */
    var x0 = null, s0 = 0, movido = false;
    pista.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      x0 = e.clientX; s0 = pista.scrollLeft; movido = false;
      pista.classList.add('mt-arrastrando'); pista.setPointerCapture(e.pointerId);
    });
    pista.addEventListener('pointermove', function (e) {
      if (x0 === null) return;
      var d = e.clientX - x0; if (Math.abs(d) > 4) movido = true;
      pista.scrollLeft = s0 - d;
    });
    function soltar(e) {
      if (x0 === null) return;
      var d = e.clientX - x0, base = Math.round(s0 / pista.clientWidth);
      x0 = null; pista.classList.remove('mt-arrastrando');
      ir(Math.abs(d) > pista.clientWidth * 0.12 ? base + (d < 0 ? 1 : -1) : base);
    }
    pista.addEventListener('pointerup', soltar);
    pista.addEventListener('pointercancel', soltar);
    pista.addEventListener('click', function (e) { if (movido) { e.preventDefault(); e.stopPropagation(); } }, true);
    window.addEventListener('resize', function () { if (actual >= 0) ir(actual, false); });
    var inicial = slides.findIndex(function (s) { return s.hasAttribute('data-inicial'); });
    ir(inicial < 0 ? 0 : inicial, false);
    return {
      irAImagen: function (id) {
        var k = slides.findIndex(function (s) { return s.dataset.imgId === String(id); });
        if (k >= 0) ir(k);
      }
    };
  }

  function initProducto(raiz) {
    raiz.querySelectorAll('[data-mt-producto]').forEach(function (cont) {
      if (cont.dataset.mtProd) return; cont.dataset.mtProd = "1";
      var gal = initGaleria(cont);
      var datos = cont.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var campoId = cont.querySelector('input[name="id"]');
      var precio = cont.querySelector('[data-mt-precio]');
      var tachado = cont.querySelector('[data-mt-tachado]');
      var boton = cont.querySelector('[data-mt-boton]');
      var textoBoton = boton ? boton.dataset.texto : '';
      var textoAgotado = boton ? boton.dataset.agotado : '';
      var formato = cont.dataset.formato || '${{amount}}';
      function dinero(c) {
        var n = (c / 100).toFixed(2).split('.');
        var ent = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, ent + ',' + n[1])
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, ent)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
          .replace(/\{\{\s*amount\s*\}\}/, n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1]);
      }
      cont.querySelectorAll('.mt-prod-pastillas input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var elegidas = [];
          cont.querySelectorAll('.mt-prod-opcion').forEach(function (f) {
            var marcada = f.querySelector('input:checked'); elegidas.push(marcada ? marcada.value : null);
          });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
          if (!v) return;
          campoId.value = v.id;
          if (precio) precio.textContent = dinero(v.price);
          if (tachado) { tachado.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : ''; }
          if (boton) { boton.disabled = !v.available; boton.textContent = v.available ? textoBoton : textoAgotado; }
          if (v.featured_image && gal) { gal.irAImagen(v.featured_image.id); }
        });
      });
    });
  }

  function initTodo(e) {
    var raiz = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    initHero(raiz); initReveals(raiz); initManifiesto(raiz); initFaq(raiz); initProducto(raiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo); else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
